'use strict';

import Vue from 'vue/dist/vue.common.js';
import VueResource from 'vue-resource';

import UsersService from '../../services/users';
import OrganizaitonsService from '../../services/organizations';

Vue.use(VueResource);

const signup = {
  namespaced: true,
  state: {
    organizations: [],
    errorMessages: [],
    submitted: false,
    name: '',
    email: '',
    organizationQuery: '',
    organizationId: null,
    newOrganizationName: null
  },
  mutations: {
    setName(state, string) {
      state.name = string;
    },
    setEmail(state, string) {
      state.email = string;
    },
    setOrganizations(state, array) {
      state.organizations = array;
    },
    setOrganizationId(state, integer) {
      state.organizationId = integer;
    },
    setOrganizationQuery(state, string) {
      state.organizationQuery = string;
    },
    setNewOrganizationName(state, string) {
      state.newOrganizationName = string;
    }
  },
  actions: {
    selectOrganization({commit, state}, obj) {
      commit('setOrganizationQuery', obj.name);
      commit('setOrganizationId', obj.id);
      commit('setOrganizations', []);
    },
    getOrganizations ({commit, state}) {
      if (!!state.organizationQuery) {
        OrganizaitonsService.search(state.organizationQuery).then(response => {
          commit('setOrganizations', response.data.searchOrganizations);
        });
      }
      else {
        commit('setOrganizations', []);
        commit('setOrganizationId', null);
      }
    },
    createUser ({commit, state}) {
      state.errorMessages = [];
      UsersService.createPending(state.name, state.email, state.organizationId, state.newOrganizationName)
        .then((response) => {
          if (!!response.data.createPendingUser) {
            state.submitted = true;
          }
          else {
            state.errorMessages = response.errors;
          }
        });
    }
  }
};

export default signup;



// WEBPACK FOOTER //
// ./app/javascript/vue/vuex/modules/signup.js